/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from "react";
import DateRange from "./dateRange";
import ReactTable from "react-table";
import "./index.css";
import UserMenu from "./userMenu";
import Link from "@material-ui/core/Link";
import { Form, Field } from "react-final-form";
import AdvisorContext from "../context/context";
import Multiselect from 'multiselect-react-dropdown';
import moment from "moment";
import enumHelper from "../../support/logic/enumHelper";
import { Language } from "../../admissions/logic/enums";
import Button from '@mui/material/Button';
import Reporting from "../../common/reporting";
import SimulateAssignmentModal from "../../staff/admin/users/SimulateAssignment";
import CoverageAnalysisModal from "../../staff/admin/users/CoverageAnalysis";
import CircularProgress from '@mui/material/CircularProgress';
import Dropdown, { DropdownTrigger, DropdownContent } from "react-simple-dropdown";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Checkbox,  Typography} from '@material-ui/core';

import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function containsAll(arr, target) {
    return target.every(element => arr.includes(element));
}
function calculateAgeInMonths(dateString) {
    const contDate = new Date(dateString);
    const currentDate = new Date();

    let ageInMonths = (currentDate.getFullYear() - contDate.getFullYear()) * 12;
    ageInMonths -= contDate.getMonth();
    ageInMonths += currentDate.getMonth();

    
    if (currentDate.getDate() < contDate.getDate()) {
        ageInMonths--;
    }

    return ageInMonths;
}
// Function to get the date 30 days before now
function getDate30DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 30);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate60DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 60);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate90DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 90);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}


function generateRecentDates() {

    const dateRanges = [];
    const currentDate = new Date();
    const formattedDate = [

        String(currentDate.getMonth() + 1).padStart(2, '0'),
        String(currentDate.getDate()).padStart(2, '0'),
        currentDate.getFullYear(),
    ].join('/');
    
    const date30 = getDate30DaysAgo();
    const date60 = getDate60DaysAgo();
    const date90 = getDate90DaysAgo();
    const fmDt = formattedDate;
    dateRanges.push({
        label: ` Last 30 Days`,
        beginDate: date30,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 60 Days`,
        beginDate: date60,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 90 Days`,
        beginDate: date90,
        endDate: fmDt
    });

    return dateRanges;
}

function generateOlderDates() {
    const dateRanges = [];
    const OldDate = new Date('2000-01-01');

    const formattedDate = [
        String(OldDate.getMonth() + 1).padStart(2, '0'),
        String(OldDate.getDate()).padStart(2, '0'),
        OldDate.getFullYear(),
    ].join('/');

    const setToEndTime = (date) => {
        date.setHours(23, 59, 59);
        return date;
    };

    // Function to subtract one day
    const subtractOneDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() - 1);
        return newDate;
    };

    const date30 = subtractOneDay(setToEndTime(getDate30DaysAgo()));
    const date60 = subtractOneDay(setToEndTime(getDate60DaysAgo()));
    const date90 = subtractOneDay(setToEndTime(getDate90DaysAgo()));

    dateRanges.push({
        label: `More Than 30 Days`,
        beginDate: formattedDate,
        endDate: date30
    });
    dateRanges.push({
        label: `More Than 60 Days`,
        beginDate: formattedDate,
        endDate: date60
    });
    dateRanges.push({
        label: `More Than 90 Days`,
        beginDate: formattedDate,
        endDate: date90
    });

    return dateRanges;
}



function generateSchoolYears() {
    const currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    // If the current date is before September 1st, subtract one year
    if (currentDate < new Date(currentYear, 8, 1)) { // Months are 0-indexed
        currentYear--;
    }

    const dateRanges = [];
    for (let i = 0; i < 3; i++) {
        const beginDate = new Date(currentYear - i, 8, 1); // September 1st
        const endDate = new Date(currentYear - i + 1, 7, 31); // August 31st

       
        const formattedBeginDate = [
            
            String(beginDate.getMonth() + 1).padStart(2, '0'),
            String(beginDate.getDate()).padStart(2, '0'),
            beginDate.getFullYear(),
        ].join('/');

        const formattedEndDate = [
            
            String(endDate.getMonth() + 1).padStart(2, '0'),
            String(endDate.getDate()).padStart(2, '0'),
            endDate.getFullYear(),
        ].join('/');

        const label = `${currentYear - i} - ${currentYear - i + 1}`;

        dateRanges.push({
            label,
            beginDate: formattedBeginDate,
            endDate: formattedEndDate
        });
    }

    return dateRanges;
}



function getDateColor(dateString) {
    if (dateString == null || dateString == '') {
        return '';
    }
    const age = calculateAgeInMonths(dateString);

    switch (age) {
        case 0:
            return 'black';
            
        case 1:
            return 'gold';
            
        case 2:
            return 'darkorange';
            
        case 3:
            return 'red';
            
        default:
            return 'red';
            

    }

}


const languageOptions = enumHelper
    .getSelectOptionsList(Language);

const preSelectedReportFields = ["userProfile.firstName", "userProfile.lastName", "userProfile.address1", "userProfile.address2", "userProfile.city", "userProfile.state", "userProfile.zipCode", "userProfile.email", "userProfile.mobilePhone", "passCode"];
const skippedFields = ["passcode","advisor.deletionTime", "advisor.deleterUserId", "advisor.isDeleted", "school.district", "studentProfile.collegeId", "studentProfile.alien", "studentProfile.sasId", "studentProfile.ssn", "studentProfile.userProfileId", "userProfile.scholarshipCrusaders", "userProfile.workPhone", "userProfile.homePhone", "userProfile.emergencyContacts", "userProfile.isDeleted", "userProfile.deleterUserId", "userProfile.deletionTime", "userProfile.lastModificationTime", "userProfile.lastModifierUserId", "userProfile.creationTime", "userProfile.creatorUserId", "userProfile.domainEvents", "userProfile.id", "userProfile.userId", "userProfile.user", "userProfile.userType", "userProfile.cityId", "userProfile.bestTimeCallStart", "userProfile.primaryPhone", "userProfile.bestTimeCallEnd", "userProfile.highestLevelEducation", "userProfile.highestLevelEducationGrade", "userProfile.highestLevelEducationInUS", "userProfile.secondarySendCopy", "userProfile.schoolId", "userProfile.grade", "studentProfile.selectedInstitutionId", "studentProfile.selectedInstitutionModifiedDate", "studentProfile.otherInstitution", "studentProfile.isDeleted", "studentProfile.deleterUserId", "studentProfile.deletionTime", "studentProfile.lastModificationTime", "studentProfile.lastModifierUserId", "studentProfile.creationTime", "studentProfile.creatorUserId", "studentProfile.domainEvents", "studentProfile.id", "school.districtId", "school.userSettingSchools", "school.isActive", "school.domainEvents", "school.id", "advisor.userId", "advisor.user", "advisor.userType", "advisor.middleName", "advisor.address1", "advisor.address2", "advisor.city", "advisor.cityId", "advisor.state", "advisor.zipCode", "advisor.homePhone", "advisor.primaryPhone", "advisor.primaryLocale", "advisor.highestLevelEducation", "advisor.highestLevelEducationGrade", "advisor.highestLevelEducationInUS", "advisor.secondarySendCopy", "advisor.dateOfBirth", "advisor.schoolId", "advisor.citizenshipType", "advisor.hispanic", "advisor.race", "advisor.otherRace", "advisor.freeOrReducedLunch", "advisor.firstGeneration", "advisor.grade", "advisor.allergies", "advisor.medications", "advisor.medicalConditions", "advisor.dietaryRestrictions", "advisor.specialAccommodations", "advisor.scholarshipCrusaders", "advisor.emergencyContacts", "advisor.workPhone", "advisor.lastModificationTime", "advisor.lastModifierUserId", "family.primaryParent.grade", "family.primaryParent.firstGeneration", "family.primaryParent.freeOrReducedLunch", "family.primaryParent.race", "family.primaryParent.otherRace", "family.primaryParent.hispanic", "family.primaryParent.userId", "family.primaryParent.citizenshipType", "family.primaryParent.schoolId", "family.primaryParent.dob", "family.primaryParent.user", "family.primaryParent.userType", "family.primaryParent.cityId", "family.primaryParent.secondarySendCopy", "family.primaryParent.scholarshipCrusaders", "family.primaryParent.emergencyContacts", "family.primaryParent.isDeleted", "family.primaryParent.deleterUserId", "family.primaryParent.deletionTime", "family.primaryParent.lastModificationTime", "family.primaryParent.lastModifierUserId", "family.primaryParent.creationTime", "family.primaryParent.creatorUserId", "family.primaryParent.domainEvents", "family.primaryParent.id", "family.secondaryParent.grade", "family.secondaryParent.firstGeneration", "family.secondaryParent.freeOrReducedLunch", "family.secondaryParent.race", "family.secondaryParent.otherRace", "family.secondaryParent.hispanic", "family.secondaryParent.userId", "family.secondaryParent.citizenshipType", "family.secondaryParent.schoolId", "family.secondaryParent.dob", "family.secondaryParent.user", "family.secondaryParent.userType", "family.secondaryParent.cityId", "family.secondaryParent.secondarySendCopy", "family.secondaryParent.scholarshipCrusaders", "family.secondaryParent.emergencyContacts", "family.secondaryParent.isDeleted", "family.secondaryParent.deleterUserId", "family.secondaryParent.deletionTime", "family.secondaryParent.lastModificationTime", "family.secondaryParent.lastModifierUserId", "family.secondaryParent.creationTime", "family.secondaryParent.creatorUserId", "family.secondaryParent.domainEvents", "family.secondaryParent.id", "family.studentUserProfileId", "family.secondaryParent.highestLevelEducation", "family.secondaryParent.highestLevelEducationGrade", "family.secondaryParent.highestLevelEducationInUS", "family.secondaryParent.dateOfBirth", "family.primaryParent.dateOfBirth"];

class Caseload extends Component {

    static contextType = AdvisorContext;

    constructor(props) {
        super(props);
        
        this.state = {
            recCount: 0,
            prefilledRanges: generateSchoolYears(),
            recentRanges: generateRecentDates(),
            olderRanges: generateOlderDates(),
            showSimulate: false,
            showCoverage: false,


        };
    }

    // OWL-2293: open the run-only assignment simulator for the supervisor's team. The modal lets the
    // supervisor pick which direct report to simulate, so it is driven by the reporting structure rather
    // than the resolved advisor shown on any single caseload row.
    openTeamSimulate = () => {
        this.setState({ showSimulate: true });
    };

   
    
    componentDidMount() {
        //console.log("Cases loaded");
        if (this.context.recipients.length > 0) {
            this.setState({ recCount: this.context.recipients.length });
        }
        if (this.props.match) {
            this.context.setSelectedAdvisor(this.props.match.params.id);
        //    //console.log(this.context);
        } else {
            this.context.setSelectedAdvisor(0);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        
        if (this.context.recipients.length != this.state.recCount) {
            this.setState({ recCount: this.context.recipients.length });
        }
        
    }

    getLanguage = (input) => {

        const lan = languageOptions.filter(l => l.value == input);
        return lan.length > 0 ? lan[0].label : "English";
    }


 
    toggleMessage = (newRecipient) => {


        
            // Check if the recipient is already in the array
            const isRecipientPresent = this.context.recipients.includes(newRecipient);

            // If the recipient is present, filter it out; if not, add it
            const updatedRecipients = isRecipientPresent
                ? this.context.recipients.filter(recipient => recipient !== newRecipient)
                : [...this.context.recipients, newRecipient];

        this.context.setRecipients(updatedRecipients);
       
    }

    doFilter = (values) => {
        
        let newCases = [];
        if (values.searchFor != null && values.searchFor !== "") {
            newCases = this.context.searchArray(this.context.myCases, values.searchFor);
        }
        

        this.context.upDateFilteredCases(newCases);
        
        
    }

    // OWL-2316: reset every filter dimension in one action. When a supervisor is drilled into a direct
    // report's caseload the advisor scope comes from the route, so it is restored rather than cleared.
    handleClearAllFilters = () => {
        this.context.clearAllFilters(this.props.match ? this.props.match.params.id : 0);
    };

    toggleDates = (yr) => {
        

        const newSelectedDates = [...this.context.selectedDates];
        const existingIndex = newSelectedDates.findIndex(dateRange =>
            dateRange.label === yr.label
        );

        if (existingIndex > -1) {
            // It's already selected, so remove it
            newSelectedDates.splice(existingIndex, 1);
        } else {
            // It's not selected, so add it
            newSelectedDates.push(yr);
        }

        this.context.setSelectedDates(newSelectedDates);

        

         
    };



    customGradeOptionRenderer = (option, val, test) => {

       // const cla = this.context.applyFilters("grades").filter(flt => flt.studentProfile.currentGrade == val.value);


        return (
            <div className="filterSelection" >


                {option} 

            </div>
        );
    };


    customContactedOptionRenderer = (option, val, test) => {

       // const cla = this.context.applyFilters("contacted").filter(flt => flt.studentContactInfo.contacted == val.value);


        return (
            <div className="filterSelection" >


                {option} 

            </div>
        );
    };

    
    customInProgramOptionRenderer = (option, val, test) => {
        
     //   const cla = this.context.applyFilters("inProgram").filter(flt => flt.studentContactInfo.inProgram == val.value);
        

        return (
            <div className="filterSelection" >
               
                
                {option} 
                
            </div>
        );
    };


    customSchoolOptionRenderer = (option, val, test) => {
        let cla = []
        
      //  if (val.id) {
       //     cla = this.context.applyFilters("schools").filter(flt => flt.school != null && flt.school.id == val.id);
       // }
        


        return (
            <div className="filterSelection" >


                {option}

            </div>
        );
    };

    customDaterangeOptionRenderer = (val) => {

       
        const beginDate = new Date(val.beginDate);
        beginDate.setHours(0, 0, 0, 0);


        const endDate = new Date(val.endDate);
        endDate.setHours(23, 59, 59, 999);
        const cutoff = new Date('1/2/2000');
        const isBeginDate2000 = beginDate < cutoff;
 

     /*   const tmp1 = this.context.applyFilters("dates");
       
        const tmp = tmp1.filter(flt => {
            if (isBeginDate2000) {
               
                if (flt.studentContactInfo.lastContacted == null) {
                    return true;
                }
                const lastContacted = new Date(flt.studentContactInfo.lastContacted);
                return (lastContacted >= beginDate && lastContacted <= endDate);
            } else {
                const lastContacted = new Date(flt.studentContactInfo.lastContacted);
                return lastContacted >= beginDate && lastContacted <= endDate;
            }
            
        });
        */
        
        const isSelected = this.context.selectedDates.some(dateRange =>
            dateRange.label === val.label
        );


        

        return (
            <div className="dateFilterSelection">
                <Checkbox
                    onChange={() => this.toggleDates(val)}
                    checked={isSelected}
                />   {val.label}  
            </div>
        );
    };


    customSpecDaterangeOptionRenderer = (val) => {


        
        
                  
        const beginDate = new Date(val.beginDate);
            beginDate.setHours(0, 0, 0, 0);

            
        const endDate = new Date(val.endDate);
            endDate.setHours(23, 59, 59, 999);


        const tmp1 = this.context.applyFilters("dates").filter(flt => flt.studentContactInfo.lastContacted);
        const tmp = tmp1.filter(flt => {

            const lastContacted = new Date(flt.studentContactInfo.lastContacted);
            return lastContacted >= beginDate && lastContacted <= endDate;
        });


        const isSelected = this.context.selectedDates.some(dateRange =>
            dateRange.label === val.label
        );

        const handleRemoveClick = (e, val) => {
            e.stopPropagation(); // This stops the event from bubbling up to the parent li
            this.context.onCustomDateRangeRemove(val);
        };

        return (
            <div className="dateFilterSelection">
                <Checkbox
                    onChange={() => this.toggleDates(val)}
                    checked={isSelected}
                />   {val.label} ({tmp.length})
                <RemoveCircleOutlineIcon onClick={(e) => handleRemoveClick(e, val)} className="removeIcon" />
            </div>
        );
    };

    customTagsOptionRenderer = (option, val, test) => {

       // const cla = this.context.applyFilters("tags").filter(flt => flt.studentContactInfo.tags.some(tag => tag.tagId == val.id));
        
        
        return (
            <div className="filterSelection" style={{ color: val.color, fontWeight: '600' }}>


                {option} 

            </div>
        );
    };

    customSubTagsOptionRenderer = (option, val, test) => {

      //  const cla = this.context.applyFilters("subTags").filter(flt => flt.studentContactInfo.tags.some(tag => tag.idMatch == val.id));
        

        return (
            <div className="filterSelection" style={{ color: val.color, fontWeight: '600' }} >


                {option} 

            </div>
        );
    };

    handleMassMessaging = () => {
        
        this.props.newMessage();
    }

    logMassEvent = () => {
        
        this.props.newEntry();
    }
    logEvent = (profile) => {
        this.props.newEntry(profile);

    }
    handleOpenContactHistory = (row) => {
        const name = row.userProfile.firstName + ' ' + row.userProfile.lastName;
        this.props.showContactHistory(row.userProfile.id, name);
    }
    handleSelectAll = async () => {
        let recip = this.context.recipients;

        if (containsAll(this.context.recipients, this.context.filteredCases)) {

            this.context.filteredCases.forEach(flt => {
               
                const tmp = recip.filter(element => !this.context.filteredCases.includes(element));
                    recip = tmp;
                    
                
            })

            
        } else {

            this.context.filteredCases.forEach(flt => {
                if (recip.indexOf(flt) == -1) {
                    
                    recip.push(flt);
                }
                
            })

            
        }
        
       this.context.setRecipients(recip);
        this.setState({ recCount: recip.length }) 
    }


    renderName = () => {
        let name = this.context.myInfo.firstName + ' ' + this.context.myInfo.lastName;
        if (this.props.match && this.props.match.params.id != this.context.myBasics.userProfile.userId) {
            const adv = this.context.myBasics.subordinates.filter(flt => flt.userProfile.userId == this.props.match.params.id)
            name = adv[0].userProfile.firstName + ' ' + adv[0].userProfile.lastName;
        }
        return name;
    }

    render() {
        //console.log(this.context);
        let columns = [
            {
                Header: () => (
                    <Checkbox
                        checked={containsAll(this.context.recipients, this.context.filteredCases)}
                        onChange={this.handleSelectAll}
                        id="SelectAll"
                    />
                ), 
                accessor: "userProfile.id",
                width: 50,
                Cell: row => (
                    <Checkbox
                        onChange={() => this.toggleMessage(row.original)}
                        checked={this.context.recipients.includes(row.original)}
                        id={`select-${row.original.userProfile.id}`}
                    />
                ),

            },
            {
                Header: "Onward Id",
                accessor: "studentProfile.crusaderId",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.studentProfile.crusaderId}</div>
                ),

            },

            {
                Header: "First Name",
                accessor: "userProfile.firstName",
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>{row.original.userProfile.firstName}</div>
                ),

            },
            {
                Header: "Last Name",
                accessor: "userProfile.lastName",
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>{row.original.userProfile.lastName}</div>
                ),

            },
            {
                Header: "School / Institution",
                accessor: "schoolInst.name",
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>{row.original.schoolInst ? row.original.schoolInst.name: "N/A"}</div>
                ),

            },
            {
                Header: "Grade",
                accessor: "studentProfile.currentGrade",
                width: 75,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>{row.original.studentProfile.currentGrade}</div>
                ),

            },


            {
                Header: "Contacted",
                accessor: "studentContactInfo.contacted",
                Cell: (row) => {
                    const contacted = row.value ? "Yes" : "No";
                    return <div style={{ display: "flex", justifyContent: "center" }}><a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault(); // Prevents jumping to top
                            this.handleOpenContactHistory(row.original);
                        }}
                        className="dataCell"
                        style={{ cursor: "pointer", color: "#123225" }}
                    >{contacted}</a> </div>;
                },
                
            },
            {
                Header: "In Program",
                accessor: "studentContactInfo.inProgram",
                Cell: (row) => {
                    const inProg = row.value ? "Yes" : "No";
                    return <div className="dataCell"  style={{ textAlign: "center" }}>{inProg}</div>;
                },

            },
                {
                Header: "Last Contact",
                    accessor: "studentContactInfo.lastContacted",
                    Cell: (row) => {
                        const lCont = row.value !== null ? moment(row.value).format("M/D/YY h:mm a") : "";
                        return<div style={{ display: "flex", justifyContent: "center" }}><a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault(); // Prevents jumping to top
                            this.handleOpenContactHistory(row.original);
                        }}
                        className="dataCell"
                            style={{ cursor: "pointer", color: getDateColor(lCont), fontWeight: 'bold' }}
                    >{lCont}</a> </div>;
                    },

            },
            {
                Header: "Preferred Language",
                accessor: "family.primaryLanguage",
                Cell: (row) => {
                    const fam = row.original.family;
                    let lCont = fam
                        ? (this.getLanguage(fam.primaryLanguage) == "Other" ? fam.otherLanguage : this.getLanguage(fam.primaryLanguage))
                        : "";
                    return <div className="dataCell" style={{ textAlign: "center" }}>{lCont}</div>;
                },

            },

        ];
        if (this.context.myBasics.isGAP || this.context.myBasics.isHonorific || this.context.myBasics.isAccelerate || this.context.myBasics.depFamilyEngagement || this.context.myBasics.depHighSchool || this.context.myBasics.depMiddleSchool || this.context.myBasics.depPostSecondary) {
            columns.push({
                Header: "Onward Student",
                accessor: "onwardStudent",
                Cell: row => {
                    const inProg = row.value ? "Yes" : "No";
                    return <div className="dataCell" style={{ textAlign: "center" }}>{inProg}</div>;
                },
            }
            )
        }
        if (this.context.myBasics.isSupervisor) {
            columns.push({
                Header: "Coach",
                accessor: "advisor.lastName",
                Cell: row => {
                    const advisor = row.original.advisor;
                    const lastName = advisor && advisor.lastName ? advisor.lastName : '';
                    const firstName = advisor && advisor.firstName ? advisor.firstName : '';

                    return (
                        <div className="dataCell" style={{ textAlign: "center" }}>
                            {lastName && firstName ? `${lastName}, ${firstName}` : 'N/A'}
                        </div>
                    );
                },
            }
)
        }
        columns.push({

            Header: "",
            accessor: "userProfile.id",
            width: 75,
            Cell: row => (
                <div className="actionMenuCell" style={{ textAlign: "center" }}><UserMenu isDirector={this.context.myBasics.isSupervisor} openProfile={this.props.openProfile} row={row.original} sendMessage={this.props.newMessage} logEntry={this.logEvent} primaryParent={row.original.primaryParent} loaded={this.context.loaded} onContactAttempt={this.props.onContactAttempt} /></div>
            ),

        })
        const showSearch = false;
        
        if (!this.context.loaded) {
            return <div>Loading...</div>;
        }
        const nulls = this.context.myCases.filter(flt => flt.display == null);
        
        return (
            <div className="caseloadWorkArea">
               
                <div className="caseloadHeader">
                    {this.props.match ? <Link
                        className={"dashboardLink"} onClick={() => this.props.goBack()}
                    >
                        &lt; Go Back
                    </Link> : <Link
                        className={"dashboardLink"} onClick={() => this.props.gotoLocation("dashboard")}
                    >
                        &lt; Return to Dashboard
                    </Link> }
                    <br />

                    <table className="caseloadHeaderTable">
                        <tr>
                            <td className="caseloadHeaderNameCell">
                                <span className="caseloadHeaderNameCellName">{this.renderName()} </span><br />
                                <div className="caseloadHeaderNameCellCaseload">Caseload  </div>
                                <div className="caseloadHeaderStatus">{this.context.statusMessage} &nbsp;{this.context.loaded ? null : <div >Loading Additional Data ...<CircularProgress size={15} thickness={5} color="primary" />
                                </div>}
                                </div>
                                {/* Sits with the case count rather than in the filter grid: always rendered so
                                    toggling it can't move the filters, and it leaves the grid exactly two rows. */}
                                <div className={this.context.hasActiveFilters ? "caseloadClearFiltersCell" : "caseloadClearFiltersCell caseloadClearFiltersCellHidden"}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={this.handleClearAllFilters}
                                        className="clearFiltersButton"
                                        id="ClearAllFiltersButton"
                                    >
                                        Clear All Filters
                                    </Button>
                                </div>
                            </td>
                            <td className="caseloadHeaderFitlerCell">
                                <Form onSubmit={this.doFilter} initialValues={this.state.activeClassification}>
                                    {({ handleSubmit, values, dirty, errors }) => {

                                        return (
                                            <form onSubmit={handleSubmit} FormValues={this.state.activeClassification} noValidate className="test">
                                                <div className="caseloadFilterGrid">
                                                    <div className="caseloadFilterField">
                                                        <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Tags</span>{this.context.selectedTags.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedTags.length}</span>) : null}</div>
                                                        <Multiselect
                                                            options={this.context.tagList} // Options to display in the dropdown
                                                            showCheckbox={true}
                                                            onSelect={this.context.onTagSelect} // Function will trigger on select event
                                                            onRemove={this.context.onTagRemove} // Function will trigger on remove event
                                                            displayValue="label" // Property name to display in the dropdown options
                                                            className="CasesFilterSchoolSelector"
                                                            avoidHighlightFirstOption={true}
                                                            optionValueDecorator={this.customTagsOptionRenderer}
                                                            id ="TagsFilterSelect"
                                                            selectedValues={this.context.selectedTags}
                                                        />
                                                    </div>
                                                    <div className="caseloadFilterField">
                                                        <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Subtags</span>{this.context.selectedSubTags.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedSubTags.length}</span>) : null}</div>
                                                        <Multiselect
                                                            options={this.context.subTagList} // Options to display in the dropdown
                                                            showCheckbox={true}
                                                            onSelect={this.context.onSubTagSelect} // Function will trigger on select event
                                                            onRemove={this.context.onSubTagRemove} // Function will trigger on remove event
                                                            displayValue="label" // Property name to display in the dropdown options
                                                            className="CasesFilterSchoolSelector"
                                                                avoidHighlightFirstOption={true}
                                                                optionValueDecorator={this.customSubTagsOptionRenderer}
                                                                id="SubTagsFilterSelect"
                                                                selectedValues={this.context.selectedSubTags}
                                                        />
                                                    </div>
                                                        
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Schools / Institutions</span>{this.context.selectedSchools.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedSchools.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.schoolInstList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onSchoolSelect} // Function will trigger on select event
                                                                onRemove={this.context.onSchoolRemove} // Function will trigger on remove event
                                                                selectedValues={this.context.selectedSchools }
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                className="CasesFilterSchoolSelector"
                                                                avoidHighlightFirstOption={true}
                                                                showArrow={false}
                                                                name="schoolSel"
                                                                optionValueDecorator={this.customSchoolOptionRenderer}
                                                                id="SchoolFilterSelect"

                                                            />
                                                        </div>
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Grade</span>{this.context.selectedGrades.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedGrades.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.gradeList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onGradeSelect} // Function will trigger on select event
                                                                onRemove={this.context.onGradeRemove} // Function will trigger on remove event
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                selectedValues={this.context.selectedGrades}
                                                                className="CasesFilterSchoolSelector"
                                                                avoidHighlightFirstOption={true}
                                                                showArrow={false}
                                                                name="gradeSel"
                                                                optionValueDecorator={this.customGradeOptionRenderer}
                                                                id="GradeFilterSelect"
                                                            />
                                                        </div>
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Contacted</span>{this.context.selectedContacted.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedContacted.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.contactedList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onContactedSelect} // Function will trigger on select event
                                                                onRemove={this.context.onContactedRemove} // Function will trigger on remove event
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                className="CasesFilterSchoolSelector"
                                                                selectedValues={this.context.selectedContacted}
                                                                showArrow={false}
                                                                avoidHighlightFirstOption={true}
                                                                name="contactedSel"
                                                                optionValueDecorator={this.customContactedOptionRenderer}
                                                                id="ContactedFilterSelect"
                                                            />
                                                        </div>
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">In Program</span>{this.context.selectedInProgram.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedInProgram.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.inProgramList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onInProgramSelect} // Function will trigger on select event
                                                                onRemove={this.context.onInProgramRemove} // Function will trigger on remove event
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                className="CasesFilterSchoolSelector"
                                                                selectedValues={this.context.selectedInProgram}
                                                                showArrow={false}
                                                                avoidHighlightFirstOption={true}
                                                                name="inProgSel"
                                                                optionValueDecorator={this.customInProgramOptionRenderer}
                                                                id="InProgramFilterSelect"
                                                            />
                                                        </div>
                                                       
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Preferred Language</span>{this.context.selectedLanguages.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedLanguages.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.languageList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onLanguageSelect} // Function will trigger on select event
                                                                onRemove={this.context.onLanguageRemove} // Function will trigger on remove event
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                className="CasesFilterSchoolSelector"
                                                                selectedValues={this.context.selectedLanguages}
                                                                showArrow={false}
                                                                avoidHighlightFirstOption={true}
                                                                name="langSel"
                                                                id="LanguageFilterSelect"
                                                            />
                                                        </div>
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Special Groups</span>{this.context.selectedSpecialGroups.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedSpecialGroups.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.specialGroupList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onSpecialGroupSelect} // Function will trigger on select event
                                                                onRemove={this.context.onSpecialGroupRemove} // Function will trigger on remove event
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                className="CasesFilterSchoolSelector"
                                                                selectedValues={this.context.selectedSpecialGroups}
                                                                showArrow={false}
                                                                avoidHighlightFirstOption={true}
                                                                name="specialGroupSel"
                                                                id="SpecialGroupFilterSelect"
                                                            />
                                                        </div>
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">District</span>{this.context.selectedDistricts.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedDistricts.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.districtList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onDistrictSelect} // Function will trigger on select event
                                                                onRemove={this.context.onDistrictRemove} // Function will trigger on remove event
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                className="CasesFilterSchoolSelector"
                                                                selectedValues={this.context.selectedDistricts}
                                                                showArrow={false}
                                                                avoidHighlightFirstOption={true}
                                                                name="districtSel"
                                                                id="DistrictFilterSelect"
                                                            />
                                                        </div>
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Zip Code</span>{this.context.selectedZipCodes.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedZipCodes.length}</span>) : null}</div>
                                                            <Multiselect
                                                                options={this.context.zipCodeList} // Options to display in the dropdown
                                                                showCheckbox={true}
                                                                onSelect={this.context.onZipCodeSelect} // Function will trigger on select event
                                                                onRemove={this.context.onZipCodeRemove} // Function will trigger on remove event
                                                                displayValue="name" // Property name to display in the dropdown options
                                                                className="CasesFilterSchoolSelector"
                                                                selectedValues={this.context.selectedZipCodes}
                                                                showArrow={false}
                                                                avoidHighlightFirstOption={true}
                                                                name="zipCodeSel"
                                                                id="ZipCodeFilterSelect"
                                                            />
                                                        </div>
                                                    {showSearch > 0 ? (
                                                        <div className="caseloadFilterField">
                                                            <div className="caseloadFilterLabel">Search</div>
                                                            <Field
                                                                component={"input"}
                                                                name="searchFor"
                                                                label="Search For"
                                                                variant="outlined"
                                                                margin="dense"
                                                            />
                                                            <Link
                                                                className={"headerlink"}
                                                                onClick={handleSubmit}
                                                            >
                                                                &nbsp;   Search &nbsp;
                                                            </Link>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </form>
                                        );
                                    }}
                                </Form>
                            </td>
                            {/* Only takes a column when rows are selected; an always-present cell reserved
                                width next to the filters and left a visible gap. */}
                            {this.state.recCount > 0 ? (
                            <td className="caseloadHeaderActionCell">
                                <table className="caseloadHeaderTable">
                                        <tr><td className="caseLoadHeaderActionCellMessage">
                                            <span className="caseloadHeaderNameCellName">Total Selected</span><br/>
                                        <span className="caseloadHeaderActionCellCount">{this.state.recCount}</span>
                                    </td><td>
                                            <Button
                                                sx={{ my: 0.5 }}
                                                variant="outlined"
                                                size="small"
                                                onClick={this.handleMassMessaging}
                                                
                                                aria-label="move selected up"
                                                className="headerActionButton"
                                            >
                                                Message
                                            </Button>

                                                
                                            <br /><br />
                                            <Reporting data={this.context.recipients}
                                                preSelected={preSelectedReportFields}
                                                label="Export" doNotExport={skippedFields} className="headerActionButton" />
                                            
                                            <br /><br />
                                            <Button
                                                sx={{ my: 0.5 }}
                                                variant="outlined"
                                                size="small"
                                                onClick={this.logMassEvent}

                                                aria-label="move selected up"
                                                className="headerActionButton "
                                            >
                                                Log Entry
                                            </Button>
                                                
                                            </td>

                                            
                                        </tr>
                                        
                                        
                                    </table>
                            </td>
                            ) : null}
                            <td className="caseloadHeaderRightCell">

                                <div className="dateFilterWrapper">
                                    
                                
                                <Dropdown ref={this.assignDateDropdown}>
                                    <div className="caseloadFilterLabel"><span className="caseloadFilterLabelText">Dates</span>{this.context.selectedDates.length > 0 ? (<span className="caseloadFilterCount">{this.context.selectedDates.length}</span>) : null}</div>
                                    <DropdownTrigger className="dropDownTrigger">
                                        <div className="dateIconContainer">
                                            <span> MM / DD / YYYY </span> &nbsp; &nbsp;
                                            <CalendarMonthIcon style={{ color: '#123225' }} /> &nbsp;
                                        </div>
                                        
                                    </DropdownTrigger>


                                    <DropdownContent className="dropDownContent" style={{ position: 'absolute', zIndex: 1000 }}> 
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    className="advisor-dates-list-item">
                                                    <Typography>Custom Dates</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <ul className="advisor-dates-list">
                                                        <li className="advisor-dates-list-range-picker">
                                                            <DateRange onDateRangeSelect={this.context.onCustomDateRangeSelect} />
                                                        </li>
                                                        {this.context.datesList.map((yr, index) => (
                                                            <li className="advisor-dates-list-item" key={index} onClick={() => this.toggleDates(yr)} onKeyPress={() => this.toggleDates(yr)} >
                                                                {this.customSpecDaterangeOptionRenderer(yr)}
                                                            </li>
                                                        ))}

                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2a-content"
                                                    id="panel2a-header"
                                                    className="advisor-dates-list-item">
                                                    <Typography>Recent Contact</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <ul className="advisor-dates-list">

                                                        {this.state.recentRanges.map((yr, index) => (
                                                            <li className="advisor-dates-list-item" key={index} onClick={() => this.toggleDates(yr)} onKeyPress={() => this.toggleDates(yr)} >
                                                                {this.customDaterangeOptionRenderer(yr)}
                                                            </li>
                                                        ))}

                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2a-content"
                                                    id="panel2a-header"
                                                    className="advisor-dates-list-item">
                                                    <Typography>Older Contact</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <ul className="advisor-dates-list">

                                                        {this.state.olderRanges.map((yr, index) => (
                                                            <li className="advisor-dates-list-item" key={index} onClick={() => this.toggleDates(yr)} onKeyPress={() => this.toggleDates(yr)} >
                                                                {this.customDaterangeOptionRenderer(yr)}
                                                            </li>
                                                        ))}

                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2a-content"
                                                    id="panel2a-header"
                                                    className="advisor-dates-list-item">
                                                    <Typography>School Years</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <ul className="advisor-dates-list">
                                                        
                                                        {this.state.prefilledRanges.map((yr, index) => (
                                                            <li className="advisor-dates-list-item" key={index} onClick={() => this.toggleDates(yr)} onKeyPress={() => this.toggleDates(yr)} >
                                                                {this.customDaterangeOptionRenderer(yr)}
                                                            </li>
                                                        ))}

                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                    </DropdownContent>
                                </Dropdown>
                                
                                </div> 
                                {this.context.myBasics.isSupervisor &&
                                    (this.context.myBasics.subordinates || []).some((s) => s.userProfile) && (
                                        <div className="caseloadHeaderTools">
                                            <button
                                                type="button"
                                                className="btn btn-primary caseloadToolButton"
                                                onClick={() => this.setState({ showCoverage: true })}
                                            >
                                                Coverage Analysis
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary caseloadToolButton caseloadToolButtonLong"
                                                onClick={this.openTeamSimulate}
                                            >
                                                Simulate Coach Assignment
                                            </button>
                                        </div>
                                    )}
                                

                                

                            </td>
                        </tr>


                    </table>
                    
            </div>
                
                
                    {
                    this.context.myCases.length > 0 ? (
                <ReactTable
                data={this.context.filteredCases}
                minRows={0}
                columns={columns}
                defaultPageSize={50}
                            className="-striped -highlight tableWrapper"
                        />) : <span className="tableWrapper">Loading...</span>}

                {/* OWL-2293: run-only assignment simulator for supervisors. Opened from the "Simulate Coach
                    Assignment" button above; the supervisor picks one of their direct reports inside the modal.
                    The modal loads that advisor's current criteria from the server (scoped to the caller's team)
                    and canApply is false so committing stays Admin-only. */}
                <SimulateAssignmentModal
                    open={this.state.showSimulate}
                    onClose={() => this.setState({ showSimulate: false })}
                    advisorChoices={(this.context.myBasics.subordinates || [])
                        .filter((s) => s.userProfile)
                        .map((s) => ({
                            id: s.userProfile.id,
                            name: `${s.userProfile.lastName}, ${s.userProfile.firstName}`,
                        }))}
                    schoolOptions={this.context.schoolList}
                    specialGroupOptions={this.context.specialGroupList}
                    gradeOptions={(this.context.gradeList || []).map((g) => ({ name: g.name, grade: Number(g.value) }))}
                    loadCurrentCriteria={true}
                    canApply={false}
                />

                {/* OWL-2294: department-wide gap-and-overlap coverage for supervisors. supervisedAdvisorIds puts
                    the modal in supervisor mode so Assign/Resolve are scoped to the supervisor's own coaches
                    (the backend enforces the same scope on OverrideStudentAdvisor). */}
                <CoverageAnalysisModal
                    open={this.state.showCoverage}
                    onClose={() => this.setState({ showCoverage: false })}
                    schoolOptions={this.context.schoolList}
                    districtOptions={this.context.districtList}
                    supervisedAdvisorIds={(this.context.myBasics.subordinates || [])
                        .filter((s) => s.userProfile)
                        .map((s) => s.userProfile.id)}
                />

            </div >

        );
    };



}


export default Caseload;